import React, { useState } from "react";
import { Modal, Form, Input, Select, Button, message } from "antd";
import { ENV } from "../../../../../../Utils/constants";
import styles from "./DemoModal.module.scss";
import { useLandingLang } from "../../i18n/LandingLangContext";

const { Option } = Select;

export function DemoModal({ open, onClose }) {
  const { t } = useLandingLang();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (values) => {
    if (!ENV?.BASE_API) {
      message.error("BASE_API no configurada (ENV.BASE_API).");
      return;
    }

    setLoading(true);
    try {
      // ✅ Mantiene contrato actual (endpoint y payload)
      const payload = {
        name: values.name,
        centerName: values.center, // form 'center' -> back 'centerName'
        email: values.email,
        phone: values.phone,
        role: values.role,
      };

      const response = await fetch(`${ENV.BASE_API}/revi/public/lead`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      const data = await response.json().catch(() => ({}));
      if (!response.ok) throw new Error(data?.message || t("formError"));

      message.success(t("formSuccess"));
      form.resetFields();
      onClose?.();
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error("Error envío demo:", error);
      message.error(error?.message || t("formError"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      centered
      width={560}
      title={null}
      wrapClassName={styles.wrap}
      // ✅ reemplaza destroyOnClose (deprecated) por destroyOnHidden
      destroyOnHidden
      // ✅ reemplaza maskStyle (deprecated) por styles.mask
      mask={{ enabled: true, blur: true }}
      styles={{
        mask: {
          background: "rgba(2, 6, 23, 0.55)",
          backdropFilter: "blur(6px)",
        },
      }}
      // extra seguridad: al cerrar, limpiamos el form (aunque se destruya)
      afterClose={() => form.resetFields()}
    >
      <div className={styles.header}>
        <h3 className={styles.title}>{t("formTitle")}</h3>
        <p className={styles.subtitle}>{t("formSubtitle")}</p>
      </div>

      <div className={styles.body}>
        <Form
          form={form}
          className={styles.form}
          layout="vertical"
          onFinish={handleSubmit}
          requiredMark={false}
          // Recomendado por AntD cuando se destruye modal + form
          preserve={false}
        >
          <Form.Item
            name="name"
            label={t("formName")}
            rules={[{ required: true, message: t("formRequired") }]}
          >
            <Input size="large" placeholder={t("formNamePh")} />
          </Form.Item>

          <Form.Item
            name="center"
            label={t("formCenter")}
            rules={[{ required: true, message: t("formRequired") }]}
          >
            <Input size="large" placeholder={t("formCenterPh")} />
          </Form.Item>

          <Form.Item
            name="email"
            label={t("formEmail")}
            rules={[
              { required: true, message: t("formRequired") },
              { type: "email", message: t("formEmailInvalid") },
            ]}
          >
            <Input size="large" placeholder={t("formEmailPh")} />
          </Form.Item>

          <Form.Item
            name="phone"
            label={t("formPhone")}
            rules={[{ required: true, message: t("formRequired") }]}
          >
            <Input size="large" placeholder={t("formPhonePh")} />
          </Form.Item>

          <Form.Item
            name="role"
            label={t("formRole")}
            rules={[{ required: true, message: t("formRequired") }]}
          >
            <Select size="large" placeholder={t("formRolePh")}>
              <Option value="Dirección">{t("roleManagement")}</Option>
              <Option value="Coordinación">{t("roleCoordination")}</Option>
              <Option value="Psicología">{t("rolePsychology")}</Option>
              <Option value="Terapia Ocupacional">{t("roleOccTherapy")}</Option>
              <Option value="Fisioterapia">{t("rolePhysio")}</Option>
              <Option value="Otro">{t("roleOther")}</Option>
            </Select>
          </Form.Item>

          <Button
            type="primary"
            htmlType="submit"
            block
            size="large"
            loading={loading}
            className={styles.submitBtn}
          >
            {loading ? t("formSubmitting") : t("formSubmit")}
          </Button>
        </Form>
      </div>
    </Modal>
  );
}
